var _rect, _rect2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhase2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 131,
    viewBox: "0 0 207 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119.25,
    height: 119.25,
    rx: 11,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 0 71.3773)",
    fill: "url(#paint0_linear_541_16689)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 87.108,
    height: 87.108,
    rx: 14,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 27.7734 70.5325)",
    fill: "url(#paint1_linear_541_16689)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_16689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: -1,
    width: 66,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137 -0.000244141H71V63.9998H71.0132C71.0092 64.0761 71.0061 64.1526 71.0039 64.2292C71.0013 64.3192 71 64.4094 71 64.4998C71 74.1647 85.7746 81.9998 104 81.9998C122.225 81.9998 137 74.1647 137 64.4998C137 64.431 136.999 64.3624 136.998 64.2939C136.997 64.2626 136.996 64.2313 136.995 64.2C136.994 64.1563 136.992 64.1127 136.99 64.0692C136.989 64.046 136.988 64.0229 136.987 63.9998H137V-0.000244141Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_16689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9056 87.3083C83.222 110.556 123.98 110.556 128.471 87.3083C132.962 64.0607 133 55.3024 133 55.3024C133 31.0223 74.377 31.0222 74.377 55.3024C74.377 55.3024 74.5892 64.0607 78.9056 87.3083Z",
    fill: "#F2994A",
    stroke: "#C16C20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9056 87.3083C83.222 110.556 123.98 110.556 128.471 87.3083C132.962 64.0607 133 55.3024 133 55.3024C133 31.0223 74.377 31.0222 74.377 55.3024C74.377 55.3024 74.5892 64.0607 78.9056 87.3083Z",
    stroke: "#F2994A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2591 90.5708C79.0275 89.5401 78.9056 88.4525 78.9056 87.3083L74.377 55.3024C74.377 31.0223 133 31.0223 133 55.3024L132.097 61.679C125.204 79.0173 107.948 91.309 87.7516 91.309C84.8529 91.309 82.0147 91.0558 79.2591 90.5708Z",
    fill: "#FEAD66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.602,
    cy: 46.0223,
    rx: 20.3791,
    ry: 6.79302,
    fill: "#C97A35",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.923 25.6432C114.923 38.1488 103.601 48.2865 103.601 48.2865C103.601 48.2865 92.2793 38.1488 92.2793 25.6432C92.2793 13.1376 103.601 2.99976 103.601 2.99976C103.601 2.99976 114.923 13.1376 114.923 25.6432Z",
    fill: "#3CD035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.088 32.8123C105.487 39.2728 102.97 48.652 102.97 48.652C102.97 48.652 93.3214 47.5567 88.9223 41.0962C84.5232 34.6357 87.0399 25.2565 87.0399 25.2565C87.0399 25.2565 96.6889 26.3518 101.088 32.8123Z",
    fill: "#388134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_16689",
    x1: 45.1329,
    y1: -14.4922,
    x2: 83.8873,
    y2: 174.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_541_16689",
    x1: 32.968,
    y1: -10.586,
    x2: 61.2767,
    y2: 127.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase2);
export default __webpack_public_path__ + "static/media/phase2.805f58289e8a95371569d9caa97397ad.svg";
export { ForwardRef as ReactComponent };